import { TopTenBadgeVariant } from 'components/madad/top-ten-badge';

export const variantToImagePath: Record<TopTenBadgeVariant, string> = {
  regular: '/madad/2026/top-agent@2x.png',
  golden: '/madad/2026/top-agent-gold@2x.png',
};
